import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "./components/navbar";
import Foot from "./components/footer";
import { Colors } from "./components/colors";
import { capitalizeEveryWord, sortByProperty, forceLtrRange } from "./util";
import { mobileWidth } from "./components/constants";
import { useTranslation } from "react-i18next";
import { denormalizeString, localizeVar } from "./util.jsx";
import { Alert, AlertTitle } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';

const Company = () => {
  const { t, i18n } = useTranslation();
  const { companyName } = useParams();
  const [salaries, setSalaries] = useState([]);
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [relatedCompanies, setRelatedCompanies] = useState([]);
  const [maxSalary, setMaxSalary] = useState({});
  const [minSalary, setMinSalary] = useState({});
  const [companyDisplay, setCompanyDisplay] = useState("");
  const navigate = useNavigate();
  const [loaded, setLoaded ] = useState(false)

  //initialize  data
  useEffect(() => {
    fetchData();
  }, [companyName]);
  //intialize roles split and extremas
  useEffect(() => {
    getExtrema();
  }, [salaries]);

  //get extremas of company for desc
  function getExtrema() {
    if (salaries.length > 0) {
      setMaxSalary(
        salaries.reduce((max, current) =>
          max > current ? max : current,
        ),
      );
      setMinSalary(
        salaries.reduce((min, current) =>
          min < current ? min : current,
        ),
      );
    }
  }

  //fetch data func
  const fetchData = async () => {
    //get the company from the url and check if it exist and get the website
    fetch(
      `/api/v1/company/${companyName}?` +
        new URLSearchParams({ return_logo: true }),
      { credentials: "same-origin" },
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status == 404) {
            navigate("/404");
          }
        }
        return response.json();
      })
      .then((data) => {
        const company = JSON.parse(data.company);
        setCompanyDisplay(company.company_display_name);
        setCompanyWebsite(company.company_website);
      })
      .catch((error) => console.log(error));

    //get salaries from company
    const limit = 10
    const page = 1
    const params = new URLSearchParams({
        limit: limit.toString(),
        page: page.toString(),
      });
    params.append('company_name', companyName);

    fetch(`/api/v1/salary?${params.toString()}`, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
      })
      .then((data) => {
        setSalaries(JSON.parse(data.salaries));
        setLoaded(true);
      })
      .catch((error) => console.log(error));


    //this is the related companies fetch right now it just picks the first five
    fetch(
      `/api/v1/company?` + new URLSearchParams({ return_logo: true, limit: 5 }),
      { credentials: "same-origin" },
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status == 404) {
            navigate("/404");
          }
        }
        return response.json();
      })
      .then((data) => {
        setRelatedCompanies(JSON.parse(data.companies));
      })
      .catch((error) => console.log(error));
  };

  const processString = (string) => {
    string = string.replace("{companyDisplay}", companyDisplay).replace("{minSalary.median}", minSalary.median).replace("{capitalizeEveryWord(minSalary.role)}",capitalizeEveryWord(minSalary.role)).replace("{maxSalary.median}", maxSalary.median).replace("{capitalizeEveryWord(maxSalary.role)}", capitalizeEveryWord(maxSalary.role));
    const frankString = string.split("SAR").map((part, index, arr) =>
      index < arr.length - 1? (
        <>
        {part}
        <Currency/>
        </>
      ) : (part)
  );
    return <>{frankString}</>
  };
  return (
    <MainCol dir={i18n.dir()}>
      <Navbar />
      <Header>
        {companyWebsite && (
          <LogoWrapper>
            <img
              src={`https://img.logo.dev/${companyWebsite}?token=pk_M0m3xPUmQQaKLD399NpbYw`}
              alt={`${companyDisplay} company logo`}
            />
          </LogoWrapper>
        )}
        <CompanyName>{companyDisplay}</CompanyName>
      </Header>
      <FlexRow>
        <Page>
          <FlexRow>
            <AboutHeader>{processString(t("company_listed_title"))}</AboutHeader>
            <FindOutLink href={`/explore?company=${encodeURIComponent(companyName)}`}>
              {t("main_view_all")}
            </FindOutLink>
          </FlexRow>
          
          {/* <p>
            {processString(t("company_median_sub"))}
          </p> */}
          
          {salaries.length > 0 ? salaries.map((salary, index) => {
            const currLang = i18n.resolvedLanguage;
            return(
            <Role
              key={index}
              // onClick={() => navigate(`/salaries/${encodeURIComponent(salary.role)}`)}
            >
              <SalRow style={{  justifyContent: "space-between"}}>
                <div>{capitalizeEveryWord(denormalizeString(localizeVar(salary, "role", currLang)))}</div>
                <HugRow>
                <Currency/>
                {salary.salary_per_month.toLocaleString()}
                </HugRow>
              </SalRow>
              <SalRow style={{fontSize:"10px", flexDirection:"row"}}>
                <div>⏳ {`${forceLtrRange(salary.experience_in_yrs,currLang)} ${t("card_exp")}`}</div>
                <div>📍 {capitalizeEveryWord(denormalizeString(localizeVar(salary, "location_city", currLang)))}</div>
                <div>🗓️ {salary.created_at.slice(0, 10)}</div>
              </SalRow>
            </Role>)
          }
          ):
          (loaded &&
           (<Alert icon={<ShareIcon />} severity="info">
                <AlertTitle>{t("company_no_salaries")} </AlertTitle> 
                {t("main_no_salaries_details")}{' '}
                <FindOutLink style={{display:"inline"}} href="/addsalary">{t("main_no_salaries_link")}</FindOutLink> {t("main_no_salaries_details_part_2")}
              </Alert>))
          }
        </Page>
        <RelatedPage>
          <Page style={{ alignItems: "self-start" }}>
            <b>{t("related_companies")}</b>
            {relatedCompanies.map((company, index) => (
              <CompanyLink
                key={index}
                onClick={() => {
                  navigate(`/companies/${company.company_name}`);
                }}
              >
                <img
                  src={`https://img.logo.dev/${company.company_website}?token=pk_M0m3xPUmQQaKLD399NpbYw&size=40`}
                  alt={`${company.company_display_name} logo`}
                />
                {company.company_display_name}
              </CompanyLink>
            ))}
            <CompanyLink
              style={{ width: "100%" }}
              onClick={() => {
                window.location.href = `/companies/`;
              }}
            >
              {t("discover_companies_related")}
            </CompanyLink>
          </Page>
          {/* <Page>Featured Roles</Page> */}
        </RelatedPage>
      </FlexRow>

      <Foot />
    </MainCol>
  );
};

export default Company;

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content:center;
`;
const HugRow = styled.div`
display:flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  direction: ltr;
  color: ${Colors.moneyGreen};
`
const Currency = styled.span`
    display:inline-block;
    position: aboslute;
    height: 1em;
    width: 1em;
    mask-image: url("/static/images/Saudi_Riyal_Symbol.svg");
    background-color: currentColor;
    mask-repeat: no-repeat;
    mask-size: contain;
    mask-position:center;

`
const MainCol = styled(FlexCol)`
  justify-content: space-between;
  height: 100vh;
  margin-top: 80px;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media (max-width : ${mobileWidth}){
    flex-direction: column;
  }
`;
const SalRow = styled(FlexRow)`
  gap:10px;
  justify-content: flex-start;
  @media (max-width : ${mobileWidth}){
    justify-content: center;
  }
`
const Header = styled(FlexRow)`
  justify-content: center;
  width: fit-content;
  margin: 8px 0 8px 0;
  gap: 16px;
`;
const Role = styled(FlexCol)`
  padding: 8px;
  border: 1px solid ${Colors.lightGray};
  justify-content: center;
  margin: 8px;
  border-radius: 8px;
  padding: 32px 8px 32px 8px;
  font-size: 24px;
  width: 100%;
  background-color:${Colors.white};
  gap: 4px;
  // transition:
  //   background-color 0.3s,
  //   color 0.3s;

  // &:hover {
  //   background-color: ${Colors.darkCyan};
  //   color: ${Colors.white};
  // }
    
`;
const CompanyName = styled.h1`
  margin: 0;
  font-size: 64px;
  text-align: center;
`;

const LogoWrapper = styled.div`
  border: 1px solid ${Colors.lightGray};
  height: 128px;
  width: 128px;
  border-radius: 16px;
  overflow: hidden;
`;

const Page = styled(FlexCol)`
  padding: 16px;
  border: 1px solid lightgray;
  width: 50%;
  border-radius: 8px;
  margin: 16px;
  @media (max-width : ${mobileWidth}){
    width: 80%;
  }
`;
const AboutHeader = styled.h2`
  width: 90%;
`;
const RelatedPage = styled(FlexCol)`
  width: 25%;
  height: 100%;
  align-items: self-start;
  @media (max-width : ${mobileWidth}){
    width: 80%;
  }
`;

const CompanyLink = styled(FlexRow)`
  padding: 8px;
  cursor: pointer;
  align-items: left;
  justify-content: flex-start;
  gap: 12px;
  width: 70%;
  &:hover {
    text-decoration: underline;
  }
  @media (max-width : ${mobileWidth}){
    flex-direction: row;
  }
`;

const FindOutLink = styled.a`
  color: #0395ff;
  text-decoration: none;
  font-weight: 300;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #0458a2;
  }
`;